<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-button
                    class="item"
                    type="primary"
                    @click="on_create"
                    icon="plus"
                    v-if="permissible.indexOf('order_trademark.notary') > -1"
                    >发起公正</a-button
                >
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-spin tip="加载中" :spinning="loading">
                <div class="items">
                    <section class="item" v-for="item in data_source" :key="item.id">
                        <div class="head">
                            <div class="date">
                                <!-- {{ moment(item.created_at * 1000).format("YYYY-MM-DD HH:mm") }} -->
                                <span
                                    v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                ></span>
                            </div>

                            <div class="order-no">签约码：{{ item.signCode }}</div>
                        </div>
                        <div class="body">
                            <div class="trademark">
                                <div class="thumb">
                                    <img
                                        style="width:64px;height:64px"
                                        v-lazy="item.trademark.logo"
                                        onerror="this.src='https://scxm.oss-cn-hangzhou.aliyuncs.com/assets/images/img_missing.png'"
                                    />
                                </div>
                                <div class="detail">
                                    <div class="name">
                                        <a :href="item.trademark.release_url" target="_blank"> {{ item.trademark.markName }} </a>
                                    </div>
                                    <div class="name-b">{{ item.trademark.internationalGroup }}类</div>
                                    <div class="name-b">商标号：{{ item.apply_no }}</div>
                                </div>
                            </div>

                            <div class="from">
                                <div class="corner">转让方</div>
                                <div class="content">
                                    <div class="" v-if="item.companyName">公司名称：{{ item.companyName }}</div>
                                    <div class="" v-if="item.companyAddress">公司地址：{{ item.companyAddress }}</div>
                                    <div class="" v-if="item.uniscid">统一社会信用代码：{{ item.uniscid }}</div>
                                    <div class="" v-if="item.signerName">签约人(法人)姓名：{{ item.signerName }}</div>
                                    <div class="" v-if="item.signerCellPhone">签约人(法人)手机：{{ item.signerCellPhone }}</div>
                                    <div class="" v-if="item.signerAddress">签约人(法人)住址：{{ item.signerAddress }}</div>
                                    <div class="" v-if="item.signerIdCardNo">签约人(法人)身份证号码：{{ item.signerIdCardNo }}</div>
                                </div>
                            </div>

                            <div class="to">
                                <div class="corner">接收方</div>
                                <div class="content">
                                    <div class="" v-if="item.companyName2">公司名称：{{ item.companyName2 }}</div>
                                    <div class="" v-if="item.companyAddress2">公司地址：{{ item.companyAddress2 }}</div>
                                    <div class="" v-if="item.uniscid2">统一社会信用代码：{{ item.uniscid2 }}</div>
                                    <div class="" v-if="item.signerName2">签约人(法人)姓名：{{ item.signerName2 }}</div>
                                    <div class="" v-if="item.signerCellPhone2">签约人(法人)手机：{{ item.signerCellPhone2 }}</div>
                                    <div class="" v-if="item.signerAddress2">签约人(法人)住址：{{ item.signerAddress2 }}</div>
                                    <div class="" v-if="item.signerIdCardNo2">签约人(法人)身份证号码：{{ item.signerIdCardNo2 }}</div>
                                </div>
                            </div>

                            <div class="qrcode">
                                <img :src="item.qy_url" @click="redirect(item.qy_url)" />
                            </div>

                            <div class="user">
                                <div class="name">{{ item.user.name }}</div>
                                <div class="group">
                                    <span
                                        v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                    ></span>
                                </div>
                            </div>

                            <div class="action">
                                <a-button @click="on_delete(item)" size="small">删除</a-button>
                            </div>
                        </div>
                        <!-- <div class="foot" v-if="item.remark"><a-icon class="icon" type="info-circle" />{{ item.remark }}</div> -->
                    </section>
                </div>
            </a-spin>

            <!-- 分页 -->
            <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
                <div></div>
                <a-pagination
                    :disabled="loading"
                    v-model="pagination.current"
                    :total="pagination.total"
                    :page-size.sync="pagination.pageSize"
                    show-size-changer
                    showQuickJumper
                    :pageSizeOptions="['20', '50', '100', '200']"
                    @change="(page, pageSize) => on_pagination_change_common(page, pageSize)"
                    :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
                />
            </div>
        </div>

        <a-empty :image="simpleImage" v-if="!loading && !data_source.length" style="margin-top: 96px;">
            <a-button @click="load" icon="reload" style="margin-right:24px;">
                刷新
            </a-button>
            <a-button @click="on_reset" icon="rollback">重置</a-button>
        </a-empty>

        <!-- 创建订单 -->
        <modal_create :visible="visible_create" :callback="load" @close="visible_create = false" />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../mixins/common_pagination.js";
    import modal_create from "./modal_create.vue";
    import { Empty } from "ant-design-vue";

    export default {
        mixins: [common_pagination],
        components: { modal_create },
        beforeCreate() {
            this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
        },
        data() {
            return {
                path: "/order/notary",
                data_source: [],
                loading: false,
                visible_create: false,
                selected_record: null,
                type: "",
                wd: null,
            };
        },
        mounted() {},
        watch: {
            $route() {
                this.load();
                this.reset_query();
            },
        },
        created() {
            this.load();
            this.reset_query();
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "notary",
            });
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/notary?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },

            on_create() {
                this.selected_record = {};
                this.visible_create = true;
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除删除选中的公正记录?",
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve) => {
                            this.$http
                                .delete("/notary/" + record.id)
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_status_change(e) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query["status"] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .items {
            min-height: 200px;
            .item {
                border: 1px solid #e8e8e8;
                margin: 16px;
                border-radius: 5px;
                overflow: hidden;
                &:hover {
                    box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px 0 #0000000d, 0 12px 48px 16px #00000008;
                }
                .head {
                    padding: 8px 16px;
                    display: flex;
                    align-items: center;
                    background: #f1f1f1;
                    .date {
                        margin-right: 24px;
                        color: #9e9e9e;
                        min-width: 120px;
                    }
                }
                .body {
                    display: flex;
                    .status {
                        min-width: 70px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        font-weight: bold;
                    }
                    .corner {
                        position: absolute;
                        right: 0;
                        height: 24px;
                        background: #fafafa;
                        color: #00000073;
                        font-size: 12px;
                        text-align: center;
                        line-height: 24px;
                        padding: 1px 4px;
                    }
                    .from,
                    .to {
                        min-width: 300px;
                        position: relative;
                        border-right: 1px solid #efefef;
                        .content {
                            font-size: 12px;
                            padding: 16px;
                        }
                    }

                    .user {
                        min-width: 150px;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                    }
                    .trademark {
                        display: flex;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        min-width: 250px;
                        width: 100%;

                        .thumb {
                            margin-right: 12px;
                            text-align: center;
                            margin-left: 12px;
                        }
                        .detail {
                            padding: 16px;
                            .name {
                                font-size: 14px;
                                margin-bottom: 2px;
                            }
                            .name-b {
                                font-size: 12px;
                            }
                        }
                    }
                    .qrcode {
                        width: 200px;
                        min-width: 200px;
                        height: 200px;
                        padding: 4px;
                        border-right: 1px solid #efefef;
                        img {
                            cursor: pointer;
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .action {
                        min-width: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .foot {
                    background: #fffbe6;
                    padding: 4px 16px;
                    font-size: 12px;
                    .icon {
                        margin-right: 8px;
                    }
                }
            }
        }

        .page {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            .tips {
                font-size: 12px;
                color: #9e9e9e;
            }
        }
    }
</style>
